import "./PurchaseSubscription.css";

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import WalletTopUpModal from "Components/Popup/WalletTopUpModal/WalletTopUpModal";
import useStripeOnboardingGuard from "Hooks/useStripeOnboardingGuard";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const PurchaseSubscription = ({
  header,
  description,
  hide,
  subscribeService,
  loading,
  setLoading,
  requiredAmount,
  availableBalance,
  refreshCreditBalance,
}) => {
  const [showStripeOnboardingPopup, setShowStripeOnboardingPopup] =
    useState(false);
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [shortfallAmount, setShortfallAmount] = useState(null);
  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer
  );
  const canTopUpWallet = loggedInUserDetails?.add_credit_rights === "manager";
  const { isOnboardingRequired, stripeDashboardUrl } =
    useStripeOnboardingGuard();

  return (
    <>
      <div className="purchase-subscription-parent">
        <div className="purchase-subscription-body">
          <div className="purchase-subscription-close">
            <div onClick={() => hide(false)}>X</div>
          </div>
          <label className="purchase-subscription-heading">{header}</label>
          <label className="purchase-subscription-description">
            {description}
          </label>
          <button
            onClick={() => {
              if (!loading) {
                if (isOnboardingRequired) {
                  toast(
                    "Complete Stripe onboarding before purchasing subscriptions.",
                    {
                      type: "info",
                    }
                  );
                  setShowStripeOnboardingPopup(true);
                  return;
                }
                const required = Number(requiredAmount) || 0;
                const available = Number(availableBalance) || 0;
                if (required > 0 && available < required) {
                  const shortfall = required - available;
                  if (!canTopUpWallet) {
                    toast("You do not have rights to top up wallet", {
                      type: "info",
                    });
                    return;
                  }
                  setShortfallAmount(shortfall);
                  setShowTopUpModal(true);
                  toast(
                    `Insufficient wallet balance. Shortfall: ${shortfall.toFixed(
                      2
                    )} credits.`,
                    { type: "info" }
                  );
                  return;
                }
                subscribeService();
                setLoading(true);
              }
            }}
          >
            {loading ? "Please wait..." : "Subscribe"}
          </button>
          
        </div>
      </div>
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
      {showTopUpModal && canTopUpWallet && (
        <WalletTopUpModal
          hide={setShowTopUpModal}
          token={localStorage.getItem("token")}
          dashboardUrl={stripeDashboardUrl}
          shortfallAmount={shortfallAmount}
          onSuccess={async () => {
            if (refreshCreditBalance) {
              await refreshCreditBalance();
            }
            setShowTopUpModal(false);
          }}
        />
      )}
    </>
  );
};

export default PurchaseSubscription;
